/* eslint-disable react-native/no-inline-styles */
/* eslint-disable prettier/prettier */
import React from 'react';
import { View, Text, ScrollView } from 'react-native';
import { GridBox, Element } from '@components/frame';
import ColorWrapper from '@styles/colors';
import { isPhone } from '@helpers';
import Button from '@styles/buttons';
import Selector from '@styles/selectors';

const Content = (props) => {
  const { scale, C } = props;

  const lable = {
    fontSize: scale(15),
    paddingTop: scale(10),
    marginRight: scale(7),
    textTransform: 'uppercase',
  };

  const RenderElement = ({ variant, type, background, top }) => {
    return (
      <View
        style={{
          marginTop: scale(15),
          marginLeft: scale(5),
          marginBottom: scale(15),
          flexDirection: 'row',
          width: isPhone ? '100%' : scale(300),
        }}
      >
        <Text style={[lable, { color: C(`Label / ${background} / Secondary`, false) }]}>{type}</Text>
        <Element {...{ config: { position: { left: 150 }, flexDirection: 'row' } }}>
          <View style={{ marginRight: scale(17) }}>
            <Button {...{ variant, type, disabled: false, background }}>Button</Button>
          </View>
          <Button {...{ variant, type, disabled: true, background }}>Button</Button>
        </Element>
      </View>
    );
  };

  const types = [
    { type: 'Special' },
    { type: 'Primary' },
    { type: 'Secondary' },
    { type: 'Tertiary' },
    { type: 'Only Text' },
    { type: 'Only Text Link' },
  ];

  const Selectors = () => {
    const selectors = ['WEB', 'M', 'L', 'LIST'];
    return (
      <View
        style={{
          justifyContent: 'center',
          alignItems: 'center',
          alignContent: 'center',
          paddingLeft: scale(10),
          paddingRight: scale(10),
          marginBottom: scale(50),
        }}
      >
        <Text
          style={{
            textAlign: 'center',
            fontSize: scale(15),
            color: C('Label / Light / Secondary'),
            marginTop: scale(5),
            marginBottom: scale(5),
          }}
        >
          SELECTORS
        </Text>
        {selectors.map((s) => (
          <View
            key={s}
            style={{
              marginTop: scale(15),
              marginLeft: scale(5),
              marginBottom: scale(15),
              flexDirection: 'row',
              width: isPhone ? '100%' : scale(300),
            }}
          >
            <Text style={[lable, { color: C('Label / Light / Secondary') }]}>{s}</Text>
            <Element {...{ config: { position: { left: 100 }, flexDirection: 'row' } }}>
              <View style={{ marginRight: scale(17) }}>
                <Selector {...{ selected: true, variant: s, text: 'Selected', subText: 'Secondary' }} />
              </View>
              <Selector {...{ selected: false, variant: s, text: 'Unselected', subText: 'Secondary' }} />
            </Element>
          </View>
        ))}
      </View>
    );
  };
  const ButtonsBox = ({ background }) => {
    const header = {
      textAlign: 'center',
      fontSize: scale(15),
      color: C(`Label / ${background} / Secondary`, false),
      marginTop: scale(5),
      marginBottom: scale(5),
    };
    return (
      <View
        style={{
          justifyContent: 'center',
          alignItems: 'center',
          alignContent: 'center',
          paddingLeft: scale(10),
          paddingRight: scale(10),
        }}
      >
        <Text style={header}>LARGE</Text>
        {types.map((item) => (
          <RenderElement key={item.type} {...{ ...item, background, variant: 'L' }} />
        ))}
        <Text style={header}>MEDIUM</Text>
        {types.map((item) => (
          <RenderElement key={item.type} {...{ ...item, background, variant: 'M' }} />
        ))}
        <Text style={header}>SMALL</Text>
        {types.map((item) => (
          <RenderElement key={item.type} {...{ ...item, background, variant: 'S' }} />
        ))}
        <Text style={header}>Dialog M</Text>
        {types.map((item) => (
          <RenderElement key={item.type} {...{ ...item, background, variant: 'Dialog M' }} />
        ))}
        <Text style={header}>Dialog L</Text>
        {types.map((item) => (
          <RenderElement key={item.type} {...{ ...item, background, variant: 'Dialog L' }} />
        ))}
      </View>
    );
  };

  return (
    <View
      style={{
        flexDirection: isPhone ? 'column' : 'row',
        marginTop: isPhone ? 160 : 130,
      }}
    >
      <ScrollView
        style={[
          {
            backgroundColor: '#FFFFFF',
            overflow: 'hidden',
          },
          !isPhone && { flex: 1 },
        ]}
      >
        {C.scheme === 'light' && <Selectors />}
        <ButtonsBox {...{ background: 'Light' }} />
        {isPhone && (
          <View style={{ width: '100%', backgroundColor: 'black' }}>
            {C.scheme === 'dark' && <Selectors />}
            <ButtonsBox {...{ background: 'Dark' }} />
          </View>
        )}
      </ScrollView>
      {!isPhone && (
        <ScrollView
          style={[
            {
              backgroundColor: 'black',
              overflow: 'hidden',
              paddingLeft: scale(10),
              paddingRight: scale(10),
              flex: 1,
            },
          ]}
        >
          {C.scheme === 'dark' && <Selectors />}
          <ButtonsBox {...{ background: 'Dark' }} />
        </ScrollView>
      )}
    </View>
  );
};

const WrappContent = (props) => {
  const { C } = props;
  return [
    <GridBox
      {...{
        backgroundColor: C('Background / Light / Detail [mobile]'),
        headerOffset: false,
      }}
    >
      <Content {...props} />
    </GridBox>,
  ];
};

export default ColorWrapper(WrappContent);
